import { render, staticRenderFns } from "./EditNotification.vue?vue&type=template&id=7b3f25f2"
import script from "./EditNotification.vue?vue&type=script&lang=js"
export * from "./EditNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports